import React from 'react';
import useApi from '../../../Hooks/useApi';
import './Project.css';
import en from '../../../language/en/Project.json';
import es from '../../../language/es/Project.json';
import { Link, withRouter } from 'react-router-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { useSpring, animated } from "react-spring";
import config from '../../../config/config.json';

const Project = ({ lang, match }) => {
	window.scrollTo(0, 1);
	console.log('match', match)
	const url = `${config.apiBaseUrl}/proyectos/${match.params.id}`;
	const { data, isLoading, isError } = useApi(url);
	const project = data;

	if (isError) {
		window.alert('Ha ocurrido un error.');
	}
	// console.log('project', project)
	const selectedLanguage = (lang === 'en') ? en : es;

	const props = useSpring({
		from: {
			opacity: 1,
			marginTop: 0,
			color: 'red',
			fontSize: 0
		},
		to: [
			{
				opacity: 1,
				marginTop: 0,
				color: '#333',
				fontSize: 70
			},
			{
				opacity: 1,
				marginTop: 0,
				color: '#3f5263',
				fontSize: 40
			}
		],
		config: {
			duration: 300,
			delay: 0
		}
	});
	return (
		<div className="Project">
			<div className="container">
				<div className="heading">
					<h2><animated.strong style={props}>{selectedLanguage.title} {match.params.id}</animated.strong></h2>
				</div>
				<div className="row">
					<div className="col-md-12" style={{ background: '#fff', padding: '30px 50px', borderRadius: '25px' }}>
						<Link to="/investigation/projects">
							<i className="fa fa-reply"></i>
							Projects Page
						</Link>

						<div className="row">
							<h3>Título: </h3>
							<h4>{project.titulo}</h4>
						</div>
						<div className="row">
							<h3>Programa: </h3>
							<h4>{project.programa}</h4>
						</div>
						<div className="row">
							<h3>Entidad: </h3>
							<h4>{project.entidad_principal}</h4>
						</div>
						<div className="row">
							<h3>Jefe del Proyecto: </h3>
							<h4>{project.jefe}</h4>
						</div>
						<div className="row">
							<h3>Fecha de Inicio y Culminación: </h3>
							<h4>{project.fecha_inicio} - {project.fecha_fin}</h4>
						</div>
					</div>

				</div>
			</div>
		</div>
	)

}

export default withRouter(Project);